<router-outlet />
<p-toast />

@if (showCookieConsent) {
  <v-cookie-consent />
}

@if (authService.logoutSpinner) {
  <div class="app-main-spinner">
    <app-loading-cybera />
  </div>
}
